import * as React from "react";
import {
  EditComponent,
  CreateComponent,
  CustomComponentProps,
} from "src/components/common/Component";

export function GroupEditComponent(props: CustomComponentProps) {
  const { children } = props;
  return <EditComponent attributes={["name"]} children={children} />;
}

export function GroupCreateComponent(props: CustomComponentProps) {
  const { children } = props;
  return <CreateComponent source={"group"} children={children} />;
}
